module.exports = __webpack_public_path__ + "img/home1.33256d1c.png";